import { object, string } from 'yup';

import { TournamentGroupForm } from 'v2/types/TournamentGroupModel';

export const initialValues: TournamentGroupForm = {
  name: '',
  rewardValue: '',
  images: {
    image390Id: '',
    image768Id: null,
    image1024Id: '',
    image1300Id: null,
  },
  rewards: [],
  autoHalfPrizesEnabled: false,
  colors: {
    primary: '',
    secondary: '',
  },
};

export const validationSchema = object().shape({
  name: string().required().max(20, 'Must not contain more than 20 characters'),
  rewardValue: string().required().max(20, 'Must not contain more than 20 characters'),
  images: object().shape({
    image390Id: string().required(),
    image768Id: string().nullable(),
    image1024Id: string().required(),
    image1300Id: string().nullable(),
  }),
});
